import { useSelector } from "react-redux";
import { getLocalizedTime } from "../../../utils/timeZone";
import TextWrapper from "../../textWrapper/TextWrapper";
import styles from "./chatMessage.module.css";

const ChatMessage = ({ chat }) => {
  const { timeZone } = useSelector((state) => state.timeZone);

  const localizedSendTime = getLocalizedTime(chat.createdAt, timeZone);

  return (
    <div
      className={
        chat?.senderId
          ? `${styles.container} ${styles.userContainer}`
          : `${styles.container} ${styles.adminContainer}`
      }
    >
      <div
        className={
          chat?.senderId
            ? `${styles.chatMessageWrapper} ${styles.right}`
            : `${styles.chatMessageWrapper} ${styles.left}`
        }
      >
        <div
          className={
            chat?.senderId
              ? `${styles.message} ${styles.userMessage}`
              : `${styles.message} ${styles.adminMessage}`
          }
        >
          <TextWrapper textStyle={"textMid"}>{chat.message}</TextWrapper>
        </div>
        <div className={styles.chatTimeWrapper}>
          <TextWrapper textStyle={"textXSmall"}>
            {localizedSendTime.toLocaleString()}
          </TextWrapper>
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
